/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        //var s = skrollr.init();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

/*-----------------------------------------

            STORIE HOMEPAGE

-----------------------------------------*/
//Fai partire l'autoplay 
if(jQuery("#storie div.storia").length>0){
  var i=0;
  var numeroStorie = jQuery("#storie div.storia").length;
  var intervalStorie = setInterval(slideStorie, 8000);
  function slideStorie(){
    jQuery("#storie div.storia").removeClass('show');
    jQuery("#storie div.storia").eq(i).addClass('show');
    jQuery('.controlloStorie a').removeClass('active');
    jQuery(".controlloStorie a").eq(i).addClass('active');
    i = (i==(numeroStorie-1)) ? 0 : (i+1);
  }

  jQuery('.controlloStorie a').click(function(event){
    event.preventDefault();
    clearInterval(intervalStorie);
    var idStoria = parseInt(jQuery(this).attr('data-target'));
    jQuery("#storie div.storia").removeClass('show');
    jQuery("#storie div.storia").eq(idStoria).addClass('show');

    jQuery('.controlloStorie a').removeClass('active');
    jQuery('.controlloStorie a').eq(idStoria).addClass('active');
  });
}

/*-----------------------------------------

            NEWS FACEBOOK

-----------------------------------------*/
function caricaFacebookFeed(){
  var numeroNews = 4;
  var postString = 'limitItems='+numeroNews;
  jQuery.ajax({  
    type: "POST",  
    url: "http://www.comunitaemmaus.it/wp-content/themes/emmaus/facebookRSS/rss.php",  
    data: postString,  
    beforeSend: function(html) { // this happens before actual call
      var htmlLoading = '<i class="fa fa-spinner fa-pulse fa-2x fa-fw margin-bottom" style="margin-top: 60px;"></i>';
      jQuery("#newsEmmaus").empty().append(htmlLoading);
    },
    success: function(html){ // this happens after we get results
      jQuery("#newsEmmaus").empty().removeClass('center').append(html);

      //Fai partire l'autoplay 
      var i=0;
      var interval = setInterval(slideNews, 8000);
      function slideNews(){
        jQuery("#newsEmmaus div.news").removeClass('show');
        jQuery("#newsEmmaus div.news").eq(i).addClass('show');
        jQuery(".controlliFeed div.punto").removeClass('attivo');
        jQuery(".controlliFeed div.punto").eq(i).addClass('attivo');
        i = (i==(numeroNews-1)) ? 0 : (i+1);
      }
      //Gestisci i punti
      jQuery(".controlliFeed div.punto").click(function(){
        var indice = jQuery(".controlliFeed div.punto").index(this);
        jQuery("#newsEmmaus div.news").removeClass('show');
        jQuery("#newsEmmaus div.news").eq(indice).addClass('show');
        jQuery(".controlliFeed div.punto").removeClass('attivo');
        jQuery(".controlliFeed div.punto").eq(indice).addClass('attivo');
        clearInterval(interval);
      });
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")");
      alert(err.Message);
    }
    
  });
  return false;
}

if(jQuery("#newsEmmaus").length>0){
  caricaFacebookFeed();
  //alert(1);
}
/* 
var s = skrollr.init({
  mobileCheck : function() { return false; }, // questo serve a fare in modo che il plugin non giri su mobile
  forceHeight: false,
  smoothScrolling: true
});
*/






